import { lazy, Suspense } from 'react';


// ----------------------------------------------------------------------



const Ar = lazy(() => import('src/pages/ar/ar'));
const HomePage = lazy(() => import('src/pages/home/home'));


export const homeRoutes = [
    {
        path: 'home',
        element: (
                 <HomePage />
             ),
      },
     
      
];
